
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { PremiumAddAccountForm } from './PremiumAddAccountForm';

interface PremiumAddAccountDialogProps {
  isOpen: boolean;
  onClose: () => void;
  botId: string;
  onSuccess: () => void;
}

export const PremiumAddAccountDialog = ({ 
  isOpen, 
  onClose, 
  botId,
  onSuccess 
}: PremiumAddAccountDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Add New Account</DialogTitle>
        </DialogHeader>
        <PremiumAddAccountForm
          botId={botId}
          onSuccess={onSuccess}
          onCancel={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};
